module.exports = __webpack_public_path__ + "img/dynamic_3.7c506220.png";